import { LaunchpoolStatus, LaunchpoolStatusType } from '@flipster/apis/v1/launchpool/types';
import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';

interface Props {
  status?: LaunchpoolStatusType;
}

const StakingStatusBadge = ({ status }: Props) => {
  if (status === LaunchpoolStatus.Upcoming)
    return (
      <Badge type='tint' color='accent'>
        <FormattedMessage id='Autogen_common.r251126.s_Upcoming' />
      </Badge>
    );

  if (status === LaunchpoolStatus.Closed)
    return (
      <Badge type='tint' color='neutral'>
        <FormattedMessage id='Autogen_common.r251126.s_Closed' />
      </Badge>
    );

  return (
    <Badge type='tint' color='positive'>
      <FormattedMessage id='Autogen_common.r251126.s_Ongoing' />
    </Badge>
  );
};

export default StakingStatusBadge;
